export default __webpack_public_path__ + "static/dxbot1-917acbcecffcbd1dc14d93e33c7a59e0.jpg";